export const cde_columns = [
    { id: 'cdeId', displayName: "CDE ID", },
    { id: 'cdeName', displayName: "CDE Name", },
    { id: 'suggestedName', displayName: "Variable Name", },
    { id: 'definition', displayName: "Definition", },
    { id: 'shortDescription', displayName: "Short Description", },
    { id: 'additionalNotes', displayName: "Question Text", },
    { id: 'permissibleValues', displayName: "Permissible Values", },
    { id: 'pvDescriptions', displayName: "PV Descriptions", },
    { id: 'dataType', displayName: "Data Type", },
    { id: 'diseaseSpecificInstructions', displayName: "Disease Specific Instructions", },
    { id: 'diseaseSpecificReference', displayName: "Disease Specific Reference", },
    { id: 'population', displayName: "Population", },
    { id: 'classification', displayName: "Classification (e.g., Core)", },
    { id: 'version', displayName: "Version Number", },
    { id: 'versionDate', displayName: "Version Date", },
    { id: 'crfName', displayName: "CRF Module / Guideline", },
    { id: 'subDomainName', displayName: "Subdomain Name", },
    { id: 'domainName', displayName: "Domain Name", },
    { id: 'size', displayName: "Size", },
    { id: 'inputRestrictions', displayName: "Input Restrictions", },
    { id: 'minValue', displayName: "Min Value", },
    { id: 'maxValue', displayName: "Max Value", },
    { id: 'measurementType', displayName: "Measurement Type", },
    { id: 'externalID_LOINC', displayName: "External Id Loinc", },
    { id: 'externalID_SNOMED', displayName: "External Id Snomed", },
    { id: 'externalID_caDSR', displayName: "External Id caDSR", },
    { id: 'externalID_CDISC', displayName: "External Id CDISC", },
  ];

  export const roster_columns = [
    { id: 'grpName', displayName: 'Group Name' },
    { id: 'fullName', displayName: 'Name' },
    { id: 'institute', displayName: 'Institute' },
    { id: 'position', displayName: 'Position' },
  ];